module.exports = __webpack_public_path__ + "static/media/animation_website_market_config.c08f9980.gif";